import classNames from "classnames";
import React from "react";

export type CaTableCellProps = React.DetailedHTMLProps<
  React.TdHTMLAttributes<HTMLTableCellElement>,
  HTMLTableCellElement
>;

function CaTableCell({ className, ...props }: CaTableCellProps) {
  return (
    <td
      className={classNames("p-6 text-sm text-dark-neutral-1 font-sans-serif", className)}
      {...props}
    />
  );
}

export default CaTableCell;
